interface GetDatePickerOpenToDateParams {
  /**
   * Whether the calendar is in range selection mode.
   */
  selectsRange?: boolean

  /**
   * Currently selected date, or range start date in range mode.
   */
  selected: Date | null

  /**
   * Selected range start date.
   */
  startDate?: Date | null

  /**
   * Number of months displayed side by side in the calendar.
   */
  monthsShown: number
}

export function getDatePickerOpenToDate({
  selectsRange,
  selected,
  startDate,
  monthsShown,
}: GetDatePickerOpenToDateParams): Date | undefined {
  if (monthsShown <= 1) {
    return undefined
  }

  const anchorDate = selectsRange ? (startDate ?? selected) : selected

  return anchorDate ?? undefined
}
